export const avatarUtils = (photo, size) => {
    return photo ? photo.replace('=s96-c', `=s${size}-c`) : photo;
  };
